import { excel } from "utils";
import { ItemType } from "../utils";
import { RowExportTypeExcel } from "types";
import moment from "moment";

export function ExportExcel(props: {
    data: ItemType[],
    filter: {
        account_number: boolean,
        sub_header: boolean,
        zero_value: boolean,
        date: string
    }
}) {

    const columns = [
        { header: 'ACCOUNT', key: 'account', width: 20 },
        { header: 'NAME', key: 'name', width: 50 },
        { header: 'OPENING BALANCE', key: 'opening_balance', width: 35 },
    ]

    const dataMap: RowExportTypeExcel[] = sortByHierarchy(props.data).filter((item: any) => {
        return (
            (props.filter.sub_header || item.header_level !== 2) &&
            (props.filter.zero_value || item.opening_balance !== 0)
        )
    }).map((item: any) => {
        const textBold = Boolean(item.header_level !== 3);
        return {
            account: {
                text: `${props.filter.account_number ? item.coacode : ''}`,
                style: {
                    font: {
                        bold: textBold
                    }
                }
            },
            name: {
                text: item.coa_name,
                style: {
                    font: {
                        bold: textBold
                    }
                }
            },
            opening_balance: {
                text: item.opening_balance,
                style: {
                    font: {
                        bold: textBold
                    },
                    alignment: {
                        horizontal: 'right'
                    },
                    numFmt: '#,##0',
                }
            }
        }
    })


    excel({
        dataList: dataMap,
        column: columns,
        title: 'OPENING BALANCE',
        fileName: 'Opening_Balance',
        date: moment(props.filter.date).format('DD-MM-YYYY')
    });
}

function sortByHierarchy(dataList: any, parentId = -1) {
    const parentItems = dataList.filter((item: any) => item.parent_id === parentId);
    parentItems.sort((a: any, b: any) => a.coacode.localeCompare(b.coacode));

    return parentItems.flatMap((parent: any) => {
        return [parent, ...sortByHierarchy(dataList, parent.coa_id)];
    });
}